import {Cancer, matchCancerByType} from 'ApplicationEntry/models/ProductsRiders/Cancer/Cancer';
import * as G from 'ApplicationEntry/models/ProductsRiders/Cancer/GroupCancer';
import * as NY from 'ApplicationEntry/models/ProductsRiders/Cancer/NewYorkCancer';
import * as O from 'ApplicationEntry/models/ProductsRiders/Cancer/OrdinaryCancer';
import {Plan} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import RiderInformationBase from 'ApplicationEntry/models/ProductsRiders/RiderInformation';
import {Async, Loading} from 'Core/models/Async';
import {NonEmptyString} from 'Core/models/EmptyString';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';

export enum CancerActionType {
  CHANGE_PRODUCT_TYPE = 'cancer/CHANGE_PRODUCT_TYPE',
  CHANGE_PLAN_TYPE = 'cancer/CHANGE_PLAN_TYPE',
  CHANGE_PREMIUM = 'cancer/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'cancer/CHANGE_CALCULATED_PREMIUM',
  CHANGE_CWA = 'cancer/CHANGE_CWA',
  CHANGE_GROUP_TRUST = 'cancer/CHANGE_GROUP_TRUST',
  CHANGE_SECTION_125 = 'cancer/CHANGE_SECTION_125',
  CHANGE_REPLACEMENT = 'cancer/CHANGE_REPLACEMENT',
  CHANGE_ORIGINAL_AGE = 'cancer/CHANGE_ORIGINAL_AGE',
  CHANGE_RERATE = 'cancer/CHANGE_RERATE',
  CHANGE_POLICY_NUMBER = 'cancer/CHANGE_POLICY_NUMBER',
  CHANGE_POLICY_OPTION = 'cancer/CHANGE_POLICY_OPTION',
  CHANGE_RIDER_CODES = 'cancer/CHANGE_RIDER_CODES',
  CHANGE_RIDER_AMOUNT = 'cancer/CHANGE_RIDER_AMOUNT',
  CHANGE_OVERRIDE_BILL_FORM = 'cancer/CHANGE_OVERRIDE_BILL_FORM',
  GET_FILTERED_RIDER_CODES = 'cancer/GET_FILTERED_RIDER_CODES',
  CHANGE_RIDER_CODE2 = 'cancer/CHANGE_RIDER_CODE2',
  GET_CANCER_PRODUCTS = 'cancer/GET_CANCER_PRODUCTS',
  CHANGE_CANCER_PRODUCTS = 'cancer/CHANGE_CANCER_PRODUCTS',
  GET_CANCER_PLANTYPES = 'cancer/GET_CANCER_PLANTYPES',
  CHANGE_CANCER_PLANTYPES = 'cancer/CHANGE_CANCER_PLANTYPES',
  GET_CANCER_RIDERCODES = 'cancer/GET_CANCER_RIDERCODES',
  CHANGE_CANCER_RIDERCODES = 'cancer/CHANGE_CANCER_RIDERCODES',
  GET_CANCER_POLICY_OPTIONS = 'cancer/GET_CANCER_POLICY_OPTIONS',
  CHANGE_CANCER_POLICY_OPTIONS = 'cancer/CHANGE_CANCER_POLICY_OPTIONS',
  CHANGE_BASE_UNITS = 'cancer/CHANGE_BASE_UNITS',
  CHANGE_RETURN_OF_PREMIUM = 'cancer/CHANGE_RETURN_PREMIUM',
  CHANGE_CONTINUATION_OF_COVERAGE = 'cancer/CHANGE_CONTINUATION_OF_COVERAGE',
  CHANGE_PACKAGE = 'cancer/CHANGE_PACKAGE',
  CHANGE_PLAN = 'cancer/CHANGE_PLAN',
  CHANGE_SITUS_STATE = 'cancer/CHANGE_SITUS_STATE',
  CHANGE_J_STAMP = 'cancer/CHANGE_J_STAMP',
  GET_GROUP_CANCER_PRODUCTS = 'cancer/GET_GROUP_CANCER_PRODUCTS',
  CHANGE_GROUP_CANCER_PRODUCTS = 'cancer/CHANGE_GROUP_CANCER_PRODUCTS',
  CHANGE_PLAN_OPTION = 'cancer/CHANGE_PLAN_OPTION',
  CLEAR_CANCER = 'cancer/CLEAR_CANCER',
  CHANGE_PACKAGE_ITEM = 'cancer/CHANGE_PACKAGE_ITEM',
  CHANGE_RIDER_INFORMATION = 'cancer/CHANGE_RIDER_INFORMATION',
  CHANGE_CANCER_RIDER_INFORMATION = 'cancer/CHANGE_CANCER_RIDER_INFORMATION',
  REMOVE_RIDER = 'cancer/REMOVE_RIDER',
}

export const isCancerAction = (action: any): action is CancerAction => action.type in reverseEnum(CancerActionType);

export const changeProductType = (productType: string) =>
  createAction(CancerActionType.CHANGE_PRODUCT_TYPE, {productType});
export const changePlanType = (planType: string) => createAction(CancerActionType.CHANGE_PLAN_TYPE, {planType});
export const changePolicyOption = (policyOption: string) =>
  createAction(CancerActionType.CHANGE_POLICY_OPTION, {policyOption});
export const changePremium = (premium: string) => createAction(CancerActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(CancerActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(CancerActionType.CHANGE_CWA, {cwa});
export const changeGroupTrust = (groupTrust: boolean) =>
  createAction(CancerActionType.CHANGE_GROUP_TRUST, {groupTrust});
export const changeSection125 = (section125: boolean) =>
  createAction(CancerActionType.CHANGE_SECTION_125, {section125});
export const changeReplacement = (replacement: boolean) =>
  createAction(CancerActionType.CHANGE_REPLACEMENT, {replacement});
export const changeOriginalAge = (originalAge: number) =>
  createAction(CancerActionType.CHANGE_ORIGINAL_AGE, {originalAge});
export const changeRerate = (rerate: boolean) => createAction(CancerActionType.CHANGE_RERATE, {rerate});
export const changePolicyNumber = (policyNumber: string) =>
  createAction(CancerActionType.CHANGE_POLICY_NUMBER, {policyNumber});
export const changeRiderCodes = (riderCode: string, index: number) =>
  createAction(CancerActionType.CHANGE_RIDER_CODES, {riderCode, index});
export const changeRiderAmount = (riderAmount: number, index: number) =>
  createAction(CancerActionType.CHANGE_RIDER_AMOUNT, {riderAmount, index});
export const changeOverrideBillForm = (overrideBillForm: boolean) =>
  createAction(CancerActionType.CHANGE_OVERRIDE_BILL_FORM, {overrideBillForm});
export const changeRiderCode2 = (rc2: string) => createAction(CancerActionType.CHANGE_RIDER_CODE2, {rc2});
export const getFilteredRiderCodes = (code: number) => createAction(CancerActionType.GET_FILTERED_RIDER_CODES, {code});
export const getCancerProducts = (friendlyName: string) =>
  createAction(CancerActionType.GET_CANCER_PRODUCTS, {friendlyName});
export const getGroupCancerProducts = (caseNumber: string, planCode: string) =>
  createAction(CancerActionType.GET_GROUP_CANCER_PRODUCTS, {caseNumber, planCode});
export const changeGroupCancerProducts = (packages: Async<object[]>) =>
  createAction(CancerActionType.CHANGE_GROUP_CANCER_PRODUCTS, {packages});
export const changeCancerProducts = (products: Async<Plan[]>) =>
  createAction(CancerActionType.CHANGE_CANCER_PRODUCTS, {products});
export const getCancerPlanTypes = (family: string, product: string) =>
  createAction(CancerActionType.GET_CANCER_PLANTYPES, {family, product});
export const changeCancerPlanTypes = (planTypes: Async<string[]>) =>
  createAction(CancerActionType.CHANGE_CANCER_PLANTYPES, {planTypes});
export const getCancerPolicyOptions = (family: string, product: string) =>
  createAction(CancerActionType.GET_CANCER_POLICY_OPTIONS, {family, product});
export const changeCancerPolicyOptions = (policyOptions: Async<string[]>) =>
  createAction(CancerActionType.CHANGE_CANCER_POLICY_OPTIONS, {policyOptions});
export const getCancerRiderCodes = (product: string, family: string) =>
  createAction(CancerActionType.GET_CANCER_RIDERCODES, {product, family});
export const changeCancerRiderCodes = (riderCodes: Async<Array<{code: string; units: string[]}>>) =>
  createAction(CancerActionType.CHANGE_CANCER_RIDERCODES, {riderCodes});
export const changeBaseUnits = (baseUnits: string) => createAction(CancerActionType.CHANGE_BASE_UNITS, {baseUnits});
export const changeContinuationOfCoverage = (continuationOfCoverage: boolean) =>
  createAction(CancerActionType.CHANGE_CONTINUATION_OF_COVERAGE, {continuationOfCoverage});
export const changeReturnOfPremium = (returnOfPremium: boolean) =>
  createAction(CancerActionType.CHANGE_RETURN_OF_PREMIUM, {returnOfPremium});
export const changePlan = (plan: string) => createAction(CancerActionType.CHANGE_PLAN, {plan});
export const changePackage = (packageName: string) => createAction(CancerActionType.CHANGE_PACKAGE, {packageName});
export const changeSitusState = (situsState: string) => createAction(CancerActionType.CHANGE_SITUS_STATE, {situsState});
export const changeJStamp = (jStamp: boolean) => createAction(CancerActionType.CHANGE_J_STAMP, {jStamp});
export const changePlanOption = (planOption: string) => createAction(CancerActionType.CHANGE_PLAN_OPTION, {planOption});
export const clearCancer = () => createAction(CancerActionType.CLEAR_CANCER);
export const changePackageItem = (packageItem: object) =>
  createAction(CancerActionType.CHANGE_PACKAGE_ITEM, {packageItem});
export const changeRiderInformation = (amount: number, code: string, index: number) =>
  createAction(CancerActionType.CHANGE_RIDER_INFORMATION, {amount, code, index});
export const changeCancerRiderInformation = (riderInformation: Async<RiderInformationBase>) =>
  createAction(CancerActionType.CHANGE_CANCER_RIDER_INFORMATION, {riderInformation});
export const removeRider = (index: number) => createAction(CancerActionType.REMOVE_RIDER, {index});

export type CancerAction =
  | ReturnType<typeof changePlan>
  | ReturnType<typeof changePackage>
  | ReturnType<typeof changeProductType>
  | ReturnType<typeof changePlanType>
  | ReturnType<typeof changePolicyOption>
  | ReturnType<typeof changeGroupTrust>
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeGroupTrust>
  | ReturnType<typeof changeSection125>
  | ReturnType<typeof changeReplacement>
  | ReturnType<typeof changeOriginalAge>
  | ReturnType<typeof changeRerate>
  | ReturnType<typeof changePolicyNumber>
  | ReturnType<typeof changeRiderCodes>
  | ReturnType<typeof changeRiderAmount>
  | ReturnType<typeof changeOverrideBillForm>
  | ReturnType<typeof getFilteredRiderCodes>
  | ReturnType<typeof getCancerProducts>
  | ReturnType<typeof changeCancerProducts>
  | ReturnType<typeof getCancerPlanTypes>
  | ReturnType<typeof changeCancerPlanTypes>
  | ReturnType<typeof getCancerPolicyOptions>
  | ReturnType<typeof changeCancerPolicyOptions>
  | ReturnType<typeof getCancerRiderCodes>
  | ReturnType<typeof changeCancerRiderCodes>
  | ReturnType<typeof changeBaseUnits>
  | ReturnType<typeof changeReturnOfPremium>
  | ReturnType<typeof changeContinuationOfCoverage>
  | ReturnType<typeof changeSitusState>
  | ReturnType<typeof changeJStamp>
  | ReturnType<typeof getGroupCancerProducts>
  | ReturnType<typeof changeGroupCancerProducts>
  | ReturnType<typeof changePlanOption>
  | ReturnType<typeof clearCancer>
  | ReturnType<typeof changePackageItem>
  | ReturnType<typeof changeRiderInformation>
  | ReturnType<typeof changeCancerRiderInformation>
  | ReturnType<typeof removeRider>;

type CancerState = Cancer;

export default (state: CancerState, action: CancerAction): CancerState => {
  switch (action.type) {
    case CancerActionType.CHANGE_PRODUCT_TYPE:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeProductType(action.payload.productType),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_PLAN_TYPE:
      return matchCancerByType<Cancer>({
        Ordinary: O.changePlanType(action.payload.planType),
        Group: G.changePlanType(action.payload.planType),
        NewYork: NY.changePlanType(action.payload.planType),
      })(state);
    case CancerActionType.CHANGE_POLICY_OPTION:
      return matchCancerByType<Cancer>({
        Ordinary: O.changePolicyOption(action.payload.policyOption),
        Group: G.changePolicyOption(action.payload.policyOption),
        NewYork: NY.changePolicyOption(action.payload.policyOption),
      })(state);
    case CancerActionType.CHANGE_PREMIUM:
      return matchCancerByType<Cancer>({
        Ordinary: O.changePremium(action.payload.premium),
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
      })(state);
    case CancerActionType.CHANGE_CALCULATED_PREMIUM:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeCalculatedPremium(action.payload.calculatedPremium),
        Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
        NewYork: NY.changeCalculatedPremium(action.payload.calculatedPremium),
      })(state);
    case CancerActionType.CHANGE_CWA:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeCWA(action.payload.cwa),
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
      })(state);
    case CancerActionType.CHANGE_GROUP_TRUST:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeGroupTrust(action.payload.groupTrust),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_SECTION_125:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeSection125(action.payload.section125),
        Group: G.changeSection125(action.payload.section125),
        NewYork: NY.changeSection125(action.payload.section125),
      })(state);
    case CancerActionType.CHANGE_REPLACEMENT:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeReplacement(action.payload.replacement),
        Group: G.changeReplacement(action.payload.replacement),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_ORIGINAL_AGE:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeOriginalAge(action.payload.originalAge),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_RERATE:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeReRate(action.payload.rerate),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_POLICY_NUMBER:
      return matchCancerByType<Cancer>({
        Ordinary: O.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        Group: G.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_OVERRIDE_BILL_FORM:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeOverrideBillForm(action.payload.overrideBillForm),
        _: () => state,
      })(state);
    case CancerActionType.GET_CANCER_PRODUCTS:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeProductList(new Loading()),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_CANCER_PRODUCTS:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeProductList(action.payload.products),
        _: () => state,
      })(state);
    case CancerActionType.GET_CANCER_PLANTYPES:
      return matchCancerByType<Cancer>({
        Group: G.changePlanTypes(new Loading()),
        Ordinary: O.changePlanTypes(new Loading()),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_CANCER_PLANTYPES:
      return matchCancerByType<Cancer>({
        Group: G.changePlanTypes(action.payload.planTypes),
        Ordinary: O.changePlanTypes(action.payload.planTypes),
        _: () => state,
      })(state);
    case CancerActionType.GET_CANCER_POLICY_OPTIONS:
      return matchCancerByType<Cancer>({
        Group: G.changePolicyOptions(new Loading()),
        Ordinary: O.changePolicyOptions(new Loading()),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_CANCER_POLICY_OPTIONS:
      return matchCancerByType<Cancer>({
        Group: G.changePolicyOptions(action.payload.policyOptions),
        Ordinary: O.changePolicyOptions(action.payload.policyOptions),
        _: () => state,
      })(state);
    case CancerActionType.GET_CANCER_RIDERCODES:
      return matchCancerByType<Cancer>({
        Group: G.changeRiderCodeList(new Loading()),
        Ordinary: O.changeRiderInformation(new Loading()),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_CANCER_RIDERCODES:
      return matchCancerByType<Cancer>({
        Group: G.changeRiderCodeList(action.payload.riderCodes),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_CANCER_RIDER_INFORMATION:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeRiderInformation(action.payload.riderInformation),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_RETURN_OF_PREMIUM:
      return matchCancerByType<Cancer>({
        Group: G.changeReturnOfPremium(action.payload.returnOfPremium),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_CONTINUATION_OF_COVERAGE:
      return matchCancerByType<Cancer>({
        Group: G.changeContinuationOfCoverage(action.payload.continuationOfCoverage),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_SITUS_STATE:
      return matchCancerByType<Cancer>({
        Group: G.changeSitusState(action.payload.situsState),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_J_STAMP:
      return matchCancerByType<Cancer>({
        Group: G.changeJStamp(action.payload.jStamp),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_PLAN:
      return matchCancerByType<Cancer>({
        Group: G.changePlan(action.payload.plan),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_PACKAGE:
      return matchCancerByType<Cancer>({
        Group: G.changePackage(action.payload.packageName),
        _: () => state,
      })(state);
    case CancerActionType.GET_GROUP_CANCER_PRODUCTS:
      return matchCancerByType<Cancer>({
        Group: G.changePackageList(new Loading()),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_GROUP_CANCER_PRODUCTS:
      return matchCancerByType<Cancer>({
        Group: G.changePackageList(action.payload.packages),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_PLAN_OPTION:
      return matchCancerByType<Cancer>({
        Group: G.changePlanOption(action.payload.planOption),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_BASE_UNITS:
      return matchCancerByType<Cancer>({
        Group: G.changeBaseUnits(action.payload.baseUnits),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_PACKAGE_ITEM:
      return matchCancerByType<Cancer>({
        Group: G.changePackageItem(action.payload.packageItem),
        _: () => state,
      })(state);
    case CancerActionType.REMOVE_RIDER:
      return matchCancerByType<Cancer>({
        Ordinary: O.removeRider(action.payload.index),
        _: () => state,
      })(state);
    case CancerActionType.CHANGE_RIDER_INFORMATION:
      return matchCancerByType<Cancer>({
        Ordinary: O.changeRiderInformationData(action.payload.amount, action.payload.code, action.payload.index),
        Group: G.changeRiderInformation(action.payload.amount, action.payload.code, action.payload.index),
        NewYork: NY.changeRiderInformation(action.payload.amount, action.payload.code, action.payload.index),
      })(state);
    case CancerActionType.CLEAR_CANCER: {
      if (state.key === 'InvalidGroupCancer' || state.key === 'ValidGroupCancer') {
        return G.EmptyGroupCancer;
      } else if (state.key === 'InvalidOrdinaryCancer' || state.key === 'ValidOrdinaryCancer') {
        return O.EmptyOrdinaryCancer;
      } else if (state.key === 'InvalidNewYorkCancer' || state.key === 'ValidNewYorkCancer') {
        return NY.EmptyNewYorkCancer;
      }

      return state;
    }
    default:
      return state;
  }
};
